import noConsultationsIcon from "assets/images/pregnancy/empty-pregnancy-consultations.svg";
import { Button } from "components/ui/Button";

import style from "./PregnancyNoAnteNatalConsultationsFound.module.css";

/**
 * @param canStartConsultation false on a completed pregnancy (KIN-1942): the invitation to add
 * the first visit is withdrawn along with the button, since "add the first consultation to begin
 * monitoring" is the wrong thing to say about a pregnancy that has ended.
 */
export const PregnancyNoAnteNatalConsultationsFound = ({
  onStartConsultationButtonClick,
  canStartConsultation = true,
}) => {
  return (
    <section className={style.emptyState}>
      <img className={style.element} alt="Element" src={noConsultationsIcon} />
      <div className={style.text}>
        <div className={style.div}>
          <div className={style.textWrapper}>
            No ante-natal consultations yet
          </div>
          <p>
            {canStartConsultation
              ? "Add the first antenatal consultation to begin monitoring the health of both the mother and baby."
              : "This pregnancy was completed without any antenatal consultations recorded."}
          </p>
        </div>
        {!!canStartConsultation && (
          <Button variant="primary" onClick={onStartConsultationButtonClick}>
            Start first consultation
          </Button>
        )}
      </div>
    </section>
  );
};
